module.exports = __webpack_public_path__ + "static/hero-6f8c58c42758be6d9194d949480e5cdf.mp4";